
<template>
  <div class="flex1">
    <!-- 下拉框 -->
    <div class="selectCoordinate">
      <!-- 默认提示框 -->
      <div class="restInput button f_14 cursor_p placeholder" v-if="!storeCity.cities" @click="$emit('updateErrorTips',{type:'cities',text:'请输入工作城市'})">详细地址</div>
      <!-- 下拉菜单 -->
      <el-select class="f_14 color_40 flex1" style="width:100%" v-else v-model="formAddresses" placeholder="详细地址" ref="addresses" @change="formAddressesChange">
        <div class="historicalAddressTips f_14 color_40">您的同事正在使用以下地址</div>
        <el-option v-for="item in historicalAddress" :key="item.address" :label="item.address + (!!item.detailed_address ? item.detailed_address : '')" :value="item.address + (!!item.detailed_address ? item.detailed_address : '')"
          class='historicalAddress f_14 color_9c'>
          <div class="item">{{item.address + (!!item.detailed_address ? item.detailed_address : '')}}</div>
        </el-option>
        <!-- 
        <template v-else>
          
        </template> -->
         <div class="historicalAddressAdd f_14 color_60 cursor_p" @click="showAddress"><span class="iconfont iconadd pr"></span>添加新的工作地点</div>
      </el-select>
      <!-- 地图 -->
      <div id="cityMap"></div>
    </div>

    <!-- 添加地址弹窗 -->
    <div class="coordinate" v-if="addAddressState" @click.stop>
      <div class="content pa bg_fff">
        <div class="title f_18 color_40 font_w_b">添加新的工作地点</div>
        <div class="text f_14 color_9c">你创建的工作地址，将加入公司的地址库中与公司同事共享</div>
        <div class="flex-c">
          <div class="name f_14 color_60">街道/写字楼(必填)：</div>
          <div class="flex1 flex">
            <div class="city f_14 color_40 text_center bg_f9">{{storeCity.cities}}</div>
            <!-- 智能联想 -->
            <el-autocomplete class="searchAddress f_14 color_40 flex1" popper-class="searchJdTempsAutocomplete"
              :maxlength="50" placeholder="搜索街道/写字楼" v-model="searchAddressVal" :fetch-suggestions="addressSearch"
              @select="clickAddress" @blur="searchAddressBlur">
              <template slot-scope="{item}">
                <div class="item" v-if="item.id!==-1">
                  <div class="title" v-html="item.titleHighlight"></div>
                  <div class="name" v-html="item.addressHighlight"></div>
                </div>
                <div class="emptyState" v-else>暂无数据 </div>
              </template>
            </el-autocomplete>
          </div>
        </div>
        <div class="flex-c detail-address" @click="checkAddressVal">
          <div class="name f_14 color_60">详细地址/门牌号：</div>         
          <el-input :disabled="!searchAddressVal" maxlength="50" show-word-limit v-model="detailAddress" placeholder="请输入详细地址/门牌号"></el-input>
        </div>
        <div class="templateButtons clearfix">
          <div class="fr confirmButton text_center f_14 cursor_p" v-if="blockCoordinate.coordinate" @click="saveAddress()">保存地址</div>
          <div class="fr confirmButton text_center f_14 cursor_p bg_cf" v-else>保存地址</div>
          <div class="fr cancelButton text_center f_14 cursor_p" @click="hideAddress();">取消</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  // 所有接口
  import actions from '@/actions/index'
  import { asyncLoadJs } from '@/utils/asyncLoadJs'

  import { mapState, mapMutations } from 'vuex'

  var coordinateMap = null;
  var mapPoint = null;
  var mapMyGeo = null;
  // let loadedAMapJS = false // 是否加载完js

  export default {
    name: 'coordinate',
    props: {
      
    },
    data() {
      return {
        formAddresses:'',//表单展示地址

        addresses:'', //文字框
        historicalAddress:[{ //同事的地址
          id: -1,
          address:'暂无数据',
        }],
        addAddressState:false, //是否弹出搜索框

        searchAddressVal:'', //搜索key
        addressList:[],//搜索列表

        blockCoordinate:{
          addresses: '',
          coordinate: '', //经度,纬度
          detailed_address: ''
        },
        detailAddress: '' // 详细地址门牌号
      }
    },
    created() {
      this.updateCoordinate({ //选择地址-参数
        addresses:'',
        coordinate:'', //经度, 纬度
        detailed_address: ''
      })
      this.updateCity({ //切换城市时的-坐标
        lng:'',
        lat:''
      })
      this.updateCityPoint({ //接口-城市
        cities:'',
        city_ids:'',
      })
      //首次读取到之后同步一次
      // this.addresses = this.coordinate.addresses
      // // 判断是否加载过
      // if (!loadedAMapJS) {
      //   asyncLoadJs('//api.map.baidu.com/api?v=2.0&ak=Gnl8N9Q0DMkpkm0L9h7E2bGL5Pd2gGIA').then(() => {
      //     loadedAMapJS = true
      //   })
      // }
    },
    mounted(){
      // 循环判断有没有加载完 写在mounted生命周期里是应为高德的api依赖dom
      // let interval = setInterval(() => {
      //   if (loadedAMapJS) {
      //     clearInterval(interval)
      //     // this.initMap()
      //   }
      // }, 300)
      //初始化地图
      this.initMap()

    },
    computed: {
      ...mapState('jobEdit', ['coordinate', 'storeCity','cityPoint']),
      storeCityCities(){
        return this.storeCity.cities
      },
      storeAddresses(){
        return this.coordinate.addresses + (!!this.coordinate.detailed_address ? this.coordinate.detailed_address : '')
      },
    },
    methods: {
      ...mapMutations('jobEdit', ['updateCoordinate', 'updateCity','updateCityPoint']),
      // 检查地址是否填入
      checkAddressVal(){
        if(!this.searchAddressVal) {
          this.$message('请选择「街道/写字楼」后填写')
        }
      },
      //初始化地图
      initMap(){
        coordinateMap = new BMap.Map("cityMap");
        mapPoint = new BMap.Point(116.331398,39.897445);
        coordinateMap.centerAndZoom(mapPoint,12);
        // 创建地址解析器实例
        mapMyGeo = new BMap.Geocoder();
      },
      //【form】点击添加地址
      showAddress(){
        //收起下拉菜单
        this.$refs.addresses.blur();
        //弹出地址
        this.addAddressState = true;
        this.updateCoordinate({ //选择地址-参数
          addresses:'',
          coordinate:'', //经度, 纬度
          detailed_address: ''
       })
        document.body.style.position = 'static'
        document.body.style.overflow = 'hidden'
      },

      //【搜索】搜索地址
      addressSearch(queryString, cb){
        this.addressList = [];
        this.searchAddressVal = queryString.length ? queryString.trim() : '';
        this.addressList = [];
        cb([]);
        if(!this.searchAddressVal.length){
          return false;
        }
        //更改搜索城市名称
        coordinateMap.setCurrentCity(this.storeCity.cities);
        actions.baidu.BmapSearch({query:queryString,region:this.storeCity.cities}).then(res=>{
          if(res.status==0){

            let addressList = [];
            //整理数据
            res.results.forEach(item=>{
              let { name, address, location, city, area } = item;
              // 整理高亮文案
              addressList.push({
                title:name,
                address,
                point:location,
                desc:`${city ||''}${area ||''}${name||''}`,
                titleHighlight: this.highlightHtml(name, queryString),
                addressHighlight: this.highlightHtml(address, queryString),
              })
            })
            //抛回
            this.addressList = addressList;
            // 调用 callback 返回建议列表的数据
            if(addressList.length){
              cb([...addressList]);
            }else{
              cb([{
                id:-1,
              }])
            }

          }else{
            cb([{
              id:-1,
            }])
          }
        })
        // query=wework
        // var options = {
        //   pageCapacity:30,
        //   onSearchComplete: (results)=>{
        //     // 判断状态是否正确
        //     if (local.getStatus() == BMAP_STATUS_SUCCESS){
        //       let addressList = [];
        //       //整理数据
        //       for (var i = 0; i < results.getCurrentNumPois(); i ++){
        //         let { title, address, point } = results.getPoi(i);
        //         // 整理高亮文案
        //         addressList.push({
        //           title,
        //           address,
        //           point,
        //           titleHighlight: this.highlightHtml(title, queryString),
        //           addressHighlight: this.highlightHtml(address, queryString),
        //         })
        //       }
        //       //抛回
        //       this.addressList = addressList;
        //       // 调用 callback 返回建议列表的数据
        //       if(addressList.length){
        //         cb([...addressList]);
        //       }else{
        //         cb([{
        //           id:-1,
        //         }])
        //       }
        //     }else{
        //       cb([{
        //         id:-1,
        //       }])
        //     }
        //   }
        // };
        // var local = new BMap.LocalSearch(coordinateMap, options);
        // local.search(queryString);
      },
      //【搜索】搜索地址
      clickAddress(item){
        if(item.id === -1){
          return false;
        }
        let { address, point,desc } = item;
        this.blockCoordinate = {
          addresses: desc || address,
          coordinate: `${point.lng},${point.lat}`, //经度,纬度
        }
        // 填入详情
        // if(!!address) {
        //   this.detailAddress = address
        // }
        this.searchAddressVal = desc || address;
        this.addressList = [];
      },
      //【搜索】搜索地址-失焦
      searchAddressBlur(){
        this.addressList = [];
        // this.searchAddressVal = '';
      },
      //【搜索】确定添加地址
      saveAddress(){
        //有坐标更新
        if(this.blockCoordinate.coordinate){
          //更新坐标
          this.blockCoordinate.detailed_address = this.detailAddress
          this.updateCoordinate(this.blockCoordinate);
          //执行取消
          this.hideAddress();
        }
        this.detailAddress = ''
      },
      //【搜索】取消添加地址
      hideAddress(){
        this.addAddressState = false;
        this.searchAddressVal = '';
        this.addressList = [];
        this.detailAddress = ''
        document.body.style.position = 'initial'
        document.body.style.overflow = 'initial'
      },
      //【搜索】高亮搜索词
      highlightHtml(text,searchValue){
        if(!text || !searchValue){
          return '';
        }
        //搜索词转小写
        searchValue = searchValue.toLowerCase();
        // 标题转小写
        let textLowerCases = text.toLowerCase().split(searchValue);
        let highlightHtml = "";
        let newText = '';
        if(text.length === searchValue.length){
          return `<span class='color_blue'>${searchValue}</span>`
        }
        textLowerCases.forEach((item,index)=>{
          if(item===''){
            let Text = text.substring(newText.length<1?0:newText.length,searchValue.length)
            highlightHtml += `<span class='color_blue'>${searchValue}</span>`
          }else{
            highlightHtml += item
          }
        })

        return highlightHtml
      },

      // 获取同事使用的地址
      getColleagueAddresses(city_name){
        if(city_name){
          actions.jobs.get_colleague_addresses({city_name}).then(res=>{
            if(res.code === 1000){
              let { colleague_addresses } = res.data;
              // console.log(res);
              this.historicalAddress = colleague_addresses.length ? colleague_addresses : [{id:-1,address:'暂无数据',}];
            }else{
              this.historicalAddress = [{id:-1,address:'暂无数据',}];
            }
          })
        }else{
          this.historicalAddress = [{id:-1,address:'暂无数据',}];
        }
      },
      //地址发生变化
      formAddressesChange(){
        console.log('地址发生变化');
        if(this.formAddresses === '暂无数据'){
          this.formAddresses = this.coordinate.addresses
        }else{
          // 防止死循环
          if(this.formAddresses === this.coordinate.addresses){
            return false;
          }
          //更新坐标
          this.historicalAddress.forEach(item=>{
            if(item.address === this.formAddresses){
              //更新数据
              this.updateCoordinate({
                addresses:item.address,
                coordinate:item.position,
                detailed_address:item.detailed_address
              });
            }
          })
          
          
        }
      }
    },
    watch:{
      //监听城市发生变化
      storeCityCities(newValue, oldValue){
        // 获取同事使用的地址
        this.getColleagueAddresses(newValue);

        if(!newValue && oldValue){
          //坐标同步到库里
          this.updateCityPoint({ lng:'', lat:'', });
          //更新地址信息
          this.updateCoordinate({addresses:'',coordinate:''});
          return false;
        }

        // 将地址解析结果显示在地图上,并调整地图视野
        mapMyGeo.getPoint(`${newValue}市`, (point)=>{
          if (point) {
            let { lng, lat } = point;
            //坐标同步到库里
            this.updateCityPoint({ lng, lat, });
            //首次不删除信息
            if(oldValue){
              //更新地址信息
              this.updateCoordinate({addresses:'',coordinate:''});
            }

            coordinateMap.centerAndZoom(point, 16);
            coordinateMap.addOverlay(new BMap.Marker(point));
          }
        }, '北京市');
      },
      //监听地址发生变化
      storeAddresses(newValue, oldValue){
        this.formAddresses = newValue;
        this.$emit('updateErrorTips',{type:'cities',text:''})
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './coordinate.scss';
</style>
<style lang="scss">
.historicalAddressTips{
  line-height: 20px;
  margin:10px 0 6px;
  padding: 0 16px;
}
.historicalAddress{
  min-height: 40px;
  max-width: 500px !important;
  display: flex;
  align-items: center;
  padding: 5px 16px;
  line-height: 20px;
  color: #9c9c9c;
  white-space: normal !important;
}
.el-select-dropdown__item{
  height: auto !important;
  min-height: 34px !important;
}
.historicalAddressAdd{
  border-top: 1px solid #ECECEC;
  line-height: 50px;
  padding: 0 16px;
  .iconfont{
    margin-right: 12px;
    top: 1px;
  }
  &:hover{
    color: #4183FF;
  }
}
</style>
